import type { ElementType, ReactNode } from 'react';
import { Box, Button, Stack, Text, useColorModeValue } from '@chakra-ui/react';
import { FiInbox } from 'react-icons/fi';

export interface EmptyStateProps {
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  secondaryAction?: ReactNode;
}

const EmptyState = ({ title, description, actionLabel, onAction, secondaryAction }: EmptyStateProps) => {
  const bg = useColorModeValue('white', 'gray.800');
  const iconBg = useColorModeValue('brand.50', 'gray.700');
  const iconColor = useColorModeValue('brand.500', 'brand.300');

  return (
    <Box
      bg={bg}
      borderWidth="1px"
      borderColor={useColorModeValue('gray.200', 'gray.700')}
      rounded="lg"
      p={{ base: 8, md: 12 }}
      textAlign="center"
      boxShadow="sm"
    >
      <Box
        as={FiInbox as ElementType}
        boxSize={10}
        color={iconColor}
        bg={iconBg}
        rounded="full"
        p={2}
        mx="auto"
      />
      <Stack spacing={3} mt={6} align="center">
        <Text fontSize="lg" fontWeight="semibold" color="text.900">
          {title}
        </Text>
        <Text color="text.600" maxW="md">
          {description}
        </Text>
        {actionLabel && onAction && (
          <Button colorScheme="brand" onClick={onAction} size="sm">
            {actionLabel}
          </Button>
        )}
        {secondaryAction}
      </Stack>
    </Box>
  );
};

export default EmptyState;
